module.exports = __webpack_public_path__ + "static/img/icon_hitem2.5e2a96b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_hitem2.png
// module id = Vj1p
// module chunks = 21